/**
 * 🤖 AUTO-GENERATED API SCHEMA FILE - DO NOT EDIT DIRECTLY!
 *
 * This file is automatically generated from entity configuration files.
 * Any manual changes will be lost when the generator runs again.
 *
 * 🔄 DATA FLOW PIPELINE:
 * 1. Entity Config (config/entities/user_profiles-entity-config.ts) → Single Source of Truth
 * 2. THIS FILE → TypeBox schemas for runtime validation + API types
 * 3. API Clients → Use these schemas for request/response validation
 * 4. React Hooks → Use these types for type-safe data fetching
 * 5. Components → Import types from this schema file
 *
 * 🛠️ TO MODIFY:
 * - Edit the entity config file: config/entities/user_profiles-entity-config.ts
 * - Run: npm run schemas:gen (regenerates this file)
 * - Or run: npm run db:full-workflow (does everything)
 *
 * 📋 ARCHITECTURE:
 * - Entity configs define field publicity, types, and validation rules
 * - TypeBox schemas provide runtime validation for API requests/responses
 * - Static types are derived from TypeBox schemas for compile-time safety
 * - Query options and response types standardize API interactions
 *
 * 🔗 RELATED FILES:
 * - config/entities/user_profiles-entity-config.ts (source configuration)
 * - scripts/generate-api-clients.ts (this generator)
 * - client/api/generated_clients/generated-user_profiles-api-client.ts (API client using these schemas)
 * - client/api/generated_hooks/user_profiles.ts (React hooks using these types)
 *
 * 🔒 SECURITY: Only fields marked as 'public: true' in the config are included
 *
 * Generated at: 2026-06-22T23:44:13.693Z
 * Source config: config/entities/user_profiles-entity-config.ts
 * Public fields: 34/34 total fields
 */

import { Type, Static } from "@sinclair/typebox";

// TypeBox schemas for runtime validation (public fields only)
export const UserProfilesSchema = Type.Object({
  id: Type.String({ format: "uuid" }), // id field
  email: Type.String({ format: "email" }), // email field
  full_name: Type.String(), // full_name field
  avatar_url: Type.Union([Type.String(), Type.Null()]), // avatar_url field
  phone_number: Type.Union([Type.String(), Type.Null()]), // phone_number field
  created_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // created_at field
  updated_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // updated_at field
  organization_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // organization_id field
  user_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // user_id field
  trig_organization_name: Type.Union([Type.String(), Type.Null()]), // trig_organization_name field
  trig_organization_slug: Type.Union([Type.String(), Type.Null()]), // trig_organization_slug field
  active_subscription_id: Type.Union([
    Type.String({ format: "uuid" }),
    Type.Null(),
  ]), // active_subscription_id field
  active_subscription_type: Type.Union([Type.String(), Type.Null()]), // active_subscription_type field
  subscription_expires_at: Type.Union([
    Type.String({ format: "date-time" }),
    Type.Null(),
  ]), // subscription_expires_at field
  is_trial_user: Type.Union([Type.Boolean(), Type.Null()]), // is_trial_user field
  trial_ends_at: Type.Union([
    Type.String({ format: "date-time" }),
    Type.Null(),
  ]), // trial_ends_at field
  lifetime_value: Type.Union([Type.Number(), Type.Null()]), // lifetime_value field
  referral_code: Type.Union([Type.String(), Type.Null()]), // referral_code field
  referred_by: Type.Union([Type.String(), Type.Null()]), // referred_by field
  referral_count: Type.Union([Type.Number(), Type.Null()]), // referral_count field
  favorite_tools: Type.Union([Type.Any(), Type.Null()]), // favorite_tools field
  last_tool_used: Type.Union([Type.String(), Type.Null()]), // last_tool_used field
  last_tool_used_at: Type.Union([
    Type.String({ format: "date-time" }),
    Type.Null(),
  ]), // last_tool_used_at field
  total_tools_used: Type.Union([Type.Number(), Type.Null()]), // total_tools_used field
  onboarding_completed: Type.Union([Type.Boolean(), Type.Null()]), // onboarding_completed field
  onboarding_step: Type.Union([Type.String(), Type.Null()]), // onboarding_step field
  preferences: Type.Union([Type.Any(), Type.Null()]), // preferences field
  feature_flags: Type.Union([Type.Any(), Type.Null()]), // feature_flags field
  first_name: Type.Union([Type.String(), Type.Null()]), // first_name field
  last_name: Type.Union([Type.String(), Type.Null()]), // last_name field
  session_valid_after: Type.Union([Type.String(), Type.Null()]), // session_valid_after field
  created_by: Type.Union([Type.String(), Type.Null()]), // created_by field
  role_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // role_id field
  stripe_customer_id: Type.Union([
    Type.String({ format: "uuid" }),
    Type.Null(),
  ]), // stripe_customer_id field
});

export const CreateUserProfilesSchema = Type.Object({
  email: Type.String({ format: "email" }), // email field
  full_name: Type.String(), // full_name field
  avatar_url: Type.Union([Type.String(), Type.Null()]), // avatar_url field
  phone_number: Type.Union([Type.String(), Type.Null()]), // phone_number field
  organization_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // organization_id field
  user_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // user_id field
  trig_organization_name: Type.Union([Type.String(), Type.Null()]), // trig_organization_name field
  trig_organization_slug: Type.Union([Type.String(), Type.Null()]), // trig_organization_slug field
  active_subscription_id: Type.Union([
    Type.String({ format: "uuid" }),
    Type.Null(),
  ]), // active_subscription_id field
  active_subscription_type: Type.Union([Type.String(), Type.Null()]), // active_subscription_type field
  subscription_expires_at: Type.Union([
    Type.String({ format: "date-time" }),
    Type.Null(),
  ]), // subscription_expires_at field
  is_trial_user: Type.Union([Type.Boolean(), Type.Null()]), // is_trial_user field
  trial_ends_at: Type.Union([
    Type.String({ format: "date-time" }),
    Type.Null(),
  ]), // trial_ends_at field
  lifetime_value: Type.Union([Type.Number(), Type.Null()]), // lifetime_value field
  referral_code: Type.Union([Type.String(), Type.Null()]), // referral_code field
  referred_by: Type.Union([Type.String(), Type.Null()]), // referred_by field
  referral_count: Type.Union([Type.Number(), Type.Null()]), // referral_count field
  favorite_tools: Type.Union([Type.Any(), Type.Null()]), // favorite_tools field
  last_tool_used: Type.Union([Type.String(), Type.Null()]), // last_tool_used field
  last_tool_used_at: Type.Union([
    Type.String({ format: "date-time" }),
    Type.Null(),
  ]), // last_tool_used_at field
  total_tools_used: Type.Union([Type.Number(), Type.Null()]), // total_tools_used field
  onboarding_completed: Type.Union([Type.Boolean(), Type.Null()]), // onboarding_completed field
  onboarding_step: Type.Union([Type.String(), Type.Null()]), // onboarding_step field
  preferences: Type.Union([Type.Any(), Type.Null()]), // preferences field
  feature_flags: Type.Union([Type.Any(), Type.Null()]), // feature_flags field
  first_name: Type.Union([Type.String(), Type.Null()]), // first_name field
  last_name: Type.Union([Type.String(), Type.Null()]), // last_name field
  session_valid_after: Type.Union([Type.String(), Type.Null()]), // session_valid_after field
  created_by: Type.Union([Type.String(), Type.Null()]), // created_by field
  role_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // role_id field
  stripe_customer_id: Type.Union([
    Type.String({ format: "uuid" }),
    Type.Null(),
  ]), // stripe_customer_id field
});

export const UpdateUserProfilesSchema = Type.Object({
  email: Type.String({ format: "email" }), // email field
  full_name: Type.String(), // full_name field
  avatar_url: Type.Union([Type.String(), Type.Null()]), // avatar_url field
  phone_number: Type.Union([Type.String(), Type.Null()]), // phone_number field
  organization_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // organization_id field
  user_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // user_id field
  trig_organization_name: Type.Union([Type.String(), Type.Null()]), // trig_organization_name field
  trig_organization_slug: Type.Union([Type.String(), Type.Null()]), // trig_organization_slug field
  active_subscription_id: Type.Union([
    Type.String({ format: "uuid" }),
    Type.Null(),
  ]), // active_subscription_id field
  active_subscription_type: Type.Union([Type.String(), Type.Null()]), // active_subscription_type field
  subscription_expires_at: Type.Union([
    Type.String({ format: "date-time" }),
    Type.Null(),
  ]), // subscription_expires_at field
  is_trial_user: Type.Union([Type.Boolean(), Type.Null()]), // is_trial_user field
  trial_ends_at: Type.Union([
    Type.String({ format: "date-time" }),
    Type.Null(),
  ]), // trial_ends_at field
  lifetime_value: Type.Union([Type.Number(), Type.Null()]), // lifetime_value field
  referral_code: Type.Union([Type.String(), Type.Null()]), // referral_code field
  referred_by: Type.Union([Type.String(), Type.Null()]), // referred_by field
  referral_count: Type.Union([Type.Number(), Type.Null()]), // referral_count field
  favorite_tools: Type.Union([Type.Any(), Type.Null()]), // favorite_tools field
  last_tool_used: Type.Union([Type.String(), Type.Null()]), // last_tool_used field
  last_tool_used_at: Type.Union([
    Type.String({ format: "date-time" }),
    Type.Null(),
  ]), // last_tool_used_at field
  total_tools_used: Type.Union([Type.Number(), Type.Null()]), // total_tools_used field
  onboarding_completed: Type.Union([Type.Boolean(), Type.Null()]), // onboarding_completed field
  onboarding_step: Type.Union([Type.String(), Type.Null()]), // onboarding_step field
  preferences: Type.Union([Type.Any(), Type.Null()]), // preferences field
  feature_flags: Type.Union([Type.Any(), Type.Null()]), // feature_flags field
  first_name: Type.Union([Type.String(), Type.Null()]), // first_name field
  last_name: Type.Union([Type.String(), Type.Null()]), // last_name field
  session_valid_after: Type.Union([Type.String(), Type.Null()]), // session_valid_after field
  created_by: Type.Union([Type.String(), Type.Null()]), // created_by field
  role_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // role_id field
  stripe_customer_id: Type.Union([
    Type.String({ format: "uuid" }),
    Type.Null(),
  ]), // stripe_customer_id field
});

// TypeScript types derived from TypeBox schemas (matching server-side pattern)
export type UserProfilesRow = Static<typeof UserProfilesSchema>;
export type UserProfilesInsert = Static<typeof CreateUserProfilesSchema>;
export type UserProfilesUpdate = Static<typeof UpdateUserProfilesSchema>;

// Legacy type aliases for backward compatibility
export type UserProfiles = UserProfilesRow;
export type CreateUserProfiles = UserProfilesInsert;
export type UpdateUserProfiles = Static<typeof UpdateUserProfilesSchema>;

// Field configuration metadata
export const UserProfilesFieldConfig = {
  filterable: [
    "id",
    "organization_id",
    "user_id",
    "active_subscription_id",
    "role_id",
    "stripe_customer_id",
  ] as const,
  sortable: ["created_at", "updated_at"] as const,
  searchable: [] as const,
  required: ["id", "email", "full_name"] as const,
  readonly: ["id", "created_at", "updated_at"] as const,
} as const;

// Query options interface for API operations
import type { UnifiedQueryOptions } from "../../../../../config/search/global-search-config.js";

export interface UserProfilesQueryOptions extends UnifiedQueryOptions {}

// Response types for API operations
export interface UserProfilesResponse {
  data: UserProfiles[] | null;
  error: Error | null;
  count?: number;
}

export interface SingleUserProfilesResponse {
  data: UserProfiles | null;
  error: Error | null;
}
